import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material'
import { Divider } from '@mui/material'
import { WarningAmber, CheckCircle, ErrorOutline } from '@mui/icons-material'

export function M_MessageBoard({ title, open, onClose, body,
    footer, minWidth, warning, width, maxWidth, headerButton, backgroundColorTitle, error, success }) {

    function iconFunc() {
        if (error) {
            return <ErrorOutline style={{ color: 'var(--color-red)', marginRight: '10px' }} />
        } else if (warning) {
            return <WarningAmber style={{ color: 'var(--color-yellow)', marginRight: '10px' }} />
        } else if (success) {
            return <CheckCircle style={{ color: 'var(--color-green)', marginRight: '10px' }} />
        }
        return null
    }


    return (
        <Dialog open={open} onClose={onClose} PaperProps={{ sx: { maxWidth: maxWidth, minWidth: minWidth, width: width, zIndex: '10', position: 'sticky' } }}>
            <DialogTitle style={{ display: 'flex', alignItems: 'center' }}>
                {iconFunc()}
                <b style={{ color: 'var(--color-black)' }}>
                    {title}
                </b>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{headerButton}</div>
            </DialogTitle>
            <Divider />
            <DialogContent style={{ alignItems: 'center', justifyContent: 'center' }}>
                {body}
            </DialogContent>
            <Divider />
            {footer ? <DialogActions style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '64px' }}>
                {footer}
            </DialogActions> : <></>}
        </Dialog>
    )
}